module.exports = __webpack_public_path__ + "static/media/progman_6.5bc715b2.ico";